<template>
  <div class="time-page">
    <a-time-picker class="left" @change="changeTimeLeft" :defaultValue="moment(timeLeft, 'HH:mm')" format="HH:mm"></a-time-picker>
    <div class="center">-</div>
    <a-time-picker class="right" @change="changeTimeRight" :defaultValue="moment(timeRight, 'HH:mm')" format="HH:mm"></a-time-picker>
  </div>
</template>
<script>
  import moment from 'moment'
  export default {
    data () {
      return {
        timeLeft: '08:30',
        timeRight: '18:00',
        timeValue: '08:30 - 18:00'
      }
    },
    methods: {
      moment,
      changeTimeLeft (val, timeString) {
        this.timeLeft = timeString
        this.timeValue = this.timeLeft ? this.timeLeft + ' - ' + this.timeRight : ''
        this.$emit('change', this.timeValue)
      },
      changeTimeRight (val, timeString) {
        this.timeRight = timeString
        this.timeValue = this.timeRight ? this.timeLeft + ' - ' + this.timeRight : ''
        this.$emit('change', this.timeValue)
      }
    }
  }
</script>
<style lang="less" scoped>
  .time-page{
    padding-top: 5px;
    &::after{
      display: table;
      content: '';
      clear: both;
    }
    .left{
      float: left;
    }
    .center{
      float: left;
      width: 20px;
      text-align: center;
      line-height: 1;
      padding-top: 10px;
    }
    .right{
      float: left;
    }
  }
</style>
